import React, { Fragment } from "react";
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import { notificationConstants, notificationValidations } from "./notificationConstant";

const messageControlSx = {
    flex: "0 1 auto",
    minWidth: 0,
    minHeight: 0,
    "& textarea": { boxSizing: "border-box" },
};

const PushNotification = ({
    allowedDeviceCategories,
    allowedCompanyBrand,
    setAlert,
    pnMessage,
    handleMessageData,
    pnPlatforms,
    handlePlatformChange
}) => {
    return (
        <Fragment>
            <label className="title" style={{ fontSize: "14px", fontWeight: "bold" }}>Message</label>
            <div className="content-block position-relative send-notification-message" style={{ marginTop: "10px" }}>
                <div className="py-15">
                    <div className="send-notification-field-row">
                        <label className="title" style={{ color: 'black', fontSize: '14px' }}>Select Platforms:</label>
                        <div>
                            <FormControl component="fieldset">
                                <FormGroup>
                                    <FormControlLabel
                                        control={<Checkbox checked={pnPlatforms['iosPlatform']} onChange={(e) => {
                                            handlePlatformChange(e.target.name, e.target.checked)
                                        }} name={notificationConstants.iosPlatform} />}
                                        label="iOS"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={pnPlatforms['androidPlatform']} onChange={(e) => {
                                            handlePlatformChange(e.target.name, e.target.checked)
                                        }} name={notificationConstants.androidPlatform} />}
                                        label="Android"
                                    />
                                </FormGroup>
                            </FormControl>
                        </div>
                    </div>
                    <div className="send-notification-field-row">
                        <label className="title" style={{ color: 'black', fontSize: '14px' }}>Message:</label>
                        <Box sx={messageControlSx}>
                            <TextareaAutosize
                                aria-label="minimum height"
                                placeholder="Write a Message"
                                style={{ height: '100px', padding: "10px", width: "100%", minWidth: 280, maxWidth: 500, boxSizing: "border-box" }}
                                onChange={(e) => {
                                    handleMessageData((e.target.value).substring(0, notificationValidations?.push?.body?.maxLength))
                                }}
                                value={pnMessage}
                            />
                            <p>{(pnMessage?.length > notificationValidations?.push?.body?.maxLength ? notificationValidations?.push?.body?.maxLength : pnMessage?.length) + "/" + notificationValidations?.push?.body?.maxLength}</p>
                        </Box>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}


export default PushNotification